/**
 * Internal developer override that lets parent accounts bypass the restricted-login dialog.
 * Deliberately obscured so it is not obvious/guessable in the console or storage inspector.
 * To enable: `window.__nx7q_zR9__ = true` in the browser console.
 */
export const PARENT_LOGIN_WINDOW_KEY = '__nx7q_zR9__';

type WindowWithParentLogin = Window & {
  [PARENT_LOGIN_WINDOW_KEY]?: boolean;
};

export function isParentLoginEnabled(): boolean {
  return localStorage.getItem(PARENT_LOGIN_WINDOW_KEY) === 'true';
}

export function installParentLoginToggle(): void {
  const w = window as WindowWithParentLogin;

  Object.defineProperty(w, PARENT_LOGIN_WINDOW_KEY, {
    get: () => isParentLoginEnabled(),
    set: (value: boolean) => {
      if (value) {
        localStorage.setItem(PARENT_LOGIN_WINDOW_KEY, 'true');
      } else {
        localStorage.removeItem(PARENT_LOGIN_WINDOW_KEY);
      }
    },
    configurable: true,
  });
}
